/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { FixedAssetRevaluationService } from "services/fixed-asset-revaluation";

function FixedAssetRevaluation() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [paginationData, setPaginationData] = useState({
    size: 10,
    page: 1,
    total: 0,
  });
  const [query, setQuery] = useState({});

  const getData = async () => {
    try {
      setLoading(true);
      const response = await FixedAssetRevaluationService.paginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });
      const { items, checkCreate, paginate } = response.data || response;
      setData(items || []);
      setCheckCreate(checkCreate !== undefined ? !checkCreate : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [query, paginationData.size, paginationData.page]);

  const table = {
    columns: [
      { Header: "Số biên bản", accessor: "recordNumber", width: "15%" },
      { Header: "Ngày đánh giá", accessor: "revaluationDate", width: "15%" },
      { Header: "Hội đồng", accessor: "committeeCount", width: "15%" },
      { Header: "Số TSCĐ", accessor: "itemsCount", width: "10%" },
      { Header: "Trạng thái", accessor: "status", width: "10%" },
      { Header: "Thao tác", accessor: "action", width: "15%" },
    ],
    rows: data.map((item) => ({
      ...item,
      recordNumber: item.recordNumber || "N/A",
      committeeCount: item.revaluationCommittee?.length || 0,
      itemsCount: item.items?.length || 0,
      revaluationDate: item.revaluationDate
        ? new Date(item.revaluationDate).toLocaleDateString("vi-VN")
        : "N/A",
      status: item.status || "N/A",
      action: <ActionCell item={item} setDataTable={setData} />,
    })),
  };

  const checkCreate = true;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <SoftBox p={3}>
                <DataTable
                  table={table}
                  isSorted={false}
                  noEndBorder
                  canSearch
                  checkCreate={checkCreate}
                  query={query}
                  setQuery={setQuery}
                  paginationData={paginationData}
                  setPaginationData={setPaginationData}
                  loading={loading}
                />
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default FixedAssetRevaluation;
